function telValidator(input) {
  const regexpTest = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

  const isValid = input.length > 0 && regexpTest.test(input);

  return isValid;
}

export default telValidator;
